import { render, staticRenderFns } from "./CdlSaudePlanos.vue?vue&type=template&id=592be97c&scoped=true&"
import script from "./CdlSaudePlanos.vue?vue&type=script&lang=js&"
export * from "./CdlSaudePlanos.vue?vue&type=script&lang=js&"
import style0 from "./CdlSaudePlanos.vue?vue&type=style&index=0&id=592be97c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592be97c",
  null
  
)

export default component.exports